var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper-step',{key:("step-" + _vm.stepId),staticClass:"habiteo-body-2 export-step pb-4",class:{
        "is-complete": _vm.currentStep >= _vm.stepId,
        "is-not-complete": _vm.currentStep < _vm.stepId
    },attrs:{"id":"stepper-step","complete":_vm.currentStep > _vm.stepId,"edit-icon":'$complete',"step":_vm.stepId,"editable":_vm.currentStep > _vm.stepId}},[_vm._v("\n    "+_vm._s(_vm.step)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c2946d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myHabiteoStudio/components/StepSummaryItem.vue
// module id = null
// module chunks = 